import PropTypes from 'prop-types';
import React from 'react';
import { UX2 } from '@wsb/guac-widget-core';
import dataAids from '../../../constants/dataAids';
import { CartActions } from '@wsb/guac-widget-shared/lib/common/ols-core/core-bundle';
import * as Metrics from '../utils/trackMetric';
import * as MetricEvents from '../../../constants/metrics';
import { mapContextToProps } from '../OlsShopContext';

const errorMetrics = {
  coupon_code_invalid: () => Metrics.track(MetricEvents.COUPON_STATUS_CODE_INVALID_CLICK),
  coupon_code_expired: () => Metrics.track(MetricEvents.COUPON_STATUS_CODE_EXPIRED_CLICK),
  coupon_code_max_usage: () => Metrics.track(MetricEvents.COUPON_STATUS_CODE_MAX_USAGE_CLICK),
  coupon_code_not_eligible: () => Metrics.track(MetricEvents.COUPON_STATUS_CODE_NOT_ELIGIBLE_CLICK),
  coupon_code_already_applied: () =>
    Metrics.track(MetricEvents.COUPON_STATUS_CODE_ALREADY_APPLIED_CLICK)
};

function trackErrorMetrics(data) {
  if (data && data.response && data.response.metric && errorMetrics[data.response.metric]) {
    errorMetrics[data.response.metric]();
  }
}

export class CouponForm extends React.Component {
  constructor() {
    super(...arguments);
    this.state = {
      couponCode: '',
      message: null
    };
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    // Clears out message after any other action in cart
    // Clears out coupon code input only after API returns with success/fail
    const { validCoupon } = this.props;

    // MUST check for `null` and `false` because default is `null`
    if (validCoupon === null && newProps.validCoupon) {
      this.setState({
        message: 'success',
        couponCode: ''
      });
    } else if (validCoupon === null && newProps.validCoupon === false) {
      this.setState({
        message: 'fail',
        couponCode: ''
      });
    } else {
      this.setState({ message: null });
    }
  }

  componentDidMount() {
    Metrics.track(MetricEvents.CART_COUPON_INPUT_IMPRESSION);
  }

  handleApplyCoupon = e => {
    e.preventDefault();
    const { couponCode } = this.state;

    if (couponCode) {
      document.activeElement && document.activeElement.blur();
      CartActions.applyCoupon(couponCode).then(data => {
        const { valid } = data;

        if (valid) {
          Metrics.track(MetricEvents.COUPON_STATUS_SUCCESS_CLICK);
        } else {
          trackErrorMetrics(data);
        }
      });
    }
  };

  renderMessage() {
    const translate = this.props.translate;
    const { message } = this.state;
    const successMessage = message === 'success';
    const { Block, Error } = UX2.Element;
    const ELEMENT = successMessage ? Block : Error;

    return message ? (
      <ELEMENT
        children={ translate(successMessage ? 'coupon.validCoupon' : 'coupon.invalidCoupon') }
      />
    ) : null;
  }

  handleInputFieldKeyDown = e => {
    // Prevents `enter` key from submitting checkout
    if (e.keyCode === 13) {
      e.preventDefault();
      this.handleApplyCoupon(e);
    }
  };

  render() {
    const translate = this.props.translate;
    const { couponCode } = this.state;
    const { Block, Input, Link } = UX2.Element;

    const styles = {
      outer: {
        'width': '100%',
        '@sm': {
          width: 'auto'
        }
      },
      inner: {
        display: 'flex',
        alignItems: 'center'
      },
      input: {
        marginRight: 'medium'
      }
    };

    return (
      <Block style={ styles.outer }>
        <Block style={ styles.inner }>
          <Input
            data-aid={ dataAids.COUPON_INPUT_FIELD }
            onKeyDown={ this.handleInputFieldKeyDown }
            onChange={ e => this.setState({ couponCode: e.target.value }) }
            value={ couponCode }
            placeholder={ translate('coupon.desktopCouponCode') }
            style={ styles.input }
            disabled={ this.props.fetching }
          />
          <Link
            data-aid={ dataAids.COUPON_APPLY_BTN }
            onTouchStart={ this.handleApplyCoupon }
            onMouseDown={ this.handleApplyCoupon }
            type='submit'
            children={ translate('coupon.apply') }
            href='javascript:;'
            disabled={ this.props.fetching || !this.state.couponCode }
          />
        </Block>
        { this.renderMessage() }
      </Block>
    );
  }
}

CouponForm.defaultProps = {
  validCoupon: null,
  fetching: false,
  translate: () => {}
};

CouponForm.propTypes = {
  validCoupon: PropTypes.bool,
  fetching: PropTypes.bool,
  translate: PropTypes.func
};

export default mapContextToProps(CouponForm, context => ({
  translate: context.translate
}));
